/* ==========================================================================
   PrettyRobes — Bridesmaid Robes for the Bride & Bridal Party — collection
   Scoped to .brbp-page so listeners cannot collide with Dawn / pr-product1.js
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;

    // Filter panel toggle
    var filterToggle = root.querySelector('.filter-toggle');
    var filtersPanel = root.querySelector('.filters');
    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filtersPanel.dataset.open === 'true';
        filtersPanel.dataset.open = String(!open);
        filterToggle.setAttribute('aria-expanded', String(!open));
      });
    }

    // FAQ accordion
    root.querySelectorAll('.faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', String(!open));
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    // Quick-filter chips (visual toggle only — server-side filter wiring lives
    // in the Liquid {% if %} branches around collection.url filters; merchants
    // can also paste filtered-collection URLs onto each chip via the schema)
    root.querySelectorAll('.chip').forEach(function (chip) {
      // skip <a> chips so the link still navigates
      if (chip.tagName === 'A') return;
      chip.addEventListener('click', function () {
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Role pills — visual aria-pressed toggle. If a merchant supplies an href
    // (e.g. ?filter.p.tag=bride) the link still navigates because we don't
    // preventDefault. Without a URL it just toggles for now.
    root.querySelectorAll('.role').forEach(function (role) {
      role.addEventListener('click', function () {
        // Clear other pressed siblings for single-select feel
        root.querySelectorAll('.role[aria-pressed="true"]').forEach(function (r) {
          if (r !== role) r.setAttribute('aria-pressed', 'false');
        });
        var pressed = role.getAttribute('aria-pressed') === 'true';
        role.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Color swatches (visual aria-pressed toggle — mirrors shoulder-bags)
    root.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var pressed = sw.getAttribute('aria-pressed') === 'true';
        sw.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Palette chips (coordinate-the-squad section) — same visual toggle
    root.querySelectorAll('.pal').forEach(function (p) {
      p.addEventListener('click', function () {
        var pressed = p.getAttribute('aria-pressed') === 'true';
        p.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Sort select — submits the surrounding form on change so Shopify can
    // re-render with ?sort_by=...
    var sortSelect = root.querySelector('.sort select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }

    // Reveal-on-scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    }
  
  // Trust review link → smooth scroll to reviews section
  var trustReviewLinks = root.querySelectorAll('.trust-review-link');
  trustReviewLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.brbp-page').forEach(init);
    });
  } else {
    document.querySelectorAll('.brbp-page').forEach(init);
  }
})();
